import React from "react";


function Data() {
  return (
    <div className="impressum-page text-center">
      <div className="section-title">
        <h1>Datenschutzerklärung / Privacy Policy</h1>
      </div>

      <div className="impressum-content">
        {/* === DEUTSCH === */}
        <p>
          Diese Website erfasst oder speichert <strong>keine personenbezogenen Daten</strong>.
          Es werden <strong>keine Cookies</strong> gesetzt und <strong>keine Analysetools</strong> verwendet.
        </p>

        <p>
          Beim Besuch dieser Website werden automatisch Informationen erfasst, die
          Ihr Browser übermittelt (z. B. IP-Adresse, Datum und Uhrzeit des Zugriffs,
          verwendeter Browser, Betriebssystem). Diese Daten sind technisch erforderlich,
          um die Website korrekt anzuzeigen und dienen ausschließlich der Sicherstellung
          eines stabilen Betriebs. Eine Auswertung oder Weitergabe dieser Daten findet
          nicht statt.
        </p>

        <p>
          <strong>Hosting:</strong><br />
          Diese Website wird bei <strong>Hostinger</strong> gehostet.
          Beim Besuch der Website können technische Server-Logfiles (z. B. IP-Adresse, 
          Zeitpunkt des Zugriffs) temporär gespeichert werden. Diese Daten werden 
          ausschließlich zur Sicherstellung des technischen Betriebs verwendet.
          Der Serverstandort befindet sich in der Europäischen Union.
          Weitere Informationen zum Datenschutz des Hosters finden Sie unter{" "}
          <a
            href="https://www.hostinger.de/rechtliches/datenschutzerklaerung"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.hostinger.de/rechtliches/datenschutzerklaerung
          </a>.
        </p>

        <p>
          <strong>Verantwortlich für den Inhalt:</strong><br />
          Paul Hünecke<br />
          E-Mail: <a href="mailto:info.domvault@gmail.com">info.domvault@gmail.com</a>
        </p>

        <p>
          Diese Datenschutzerklärung wurde zuletzt aktualisiert am{" "}
          <strong>02.11.2025</strong>.
        </p>

        {/* === ENGLISH VERSION === */}
        <h2 style={{ color: "#bfa46f", marginTop: "50px" }}>English Version</h2>

        <p>
          This website does <strong>not collect or store any personal data</strong>.
          No <strong>cookies</strong> are used and no <strong>analytics or tracking tools</strong> are implemented.
        </p>

        <p>
          When visiting this website, certain information is automatically transmitted
          by your browser (such as IP address, date and time of access, browser type,
          operating system). This information is technically necessary to correctly
          display the website and is used solely to ensure a stable and secure operation.
          This data is not evaluated, shared, or used for any other purpose.
        </p>

        <p>
          <strong>Hosting:</strong><br />
          This website is hosted by <strong>Hostinger</strong>.
          When you access the website, technical server log files (e.g., IP address,
          time of access) may be stored temporarily. These data are used exclusively
          to ensure the technical operation of the website.
          The server location is within the European Union.
          More information about the host’s data protection policy can be found at{" "}
          <a
            href="https://www.hostinger.com/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.hostinger.com/privacy-policy
          </a>.
        </p>

        <p>
          <strong>Responsible for Content:</strong><br />
          Paul Hünecke<br />
          E-Mail: <a href="mailto:info.domvault@gmail.com">info.domvault@gmail.com</a>
        </p>

        <p>
          This privacy policy was last updated on{" "}
          <strong>November 2, 2025</strong>.
        </p>
      </div>
    

      <footer className="footer text-center">
        <p>© 2025 DomVault – The Vault for Valuable Names.</p>
      </footer>
    </div>
  );
}

export default Data;
